import { RankedTester, and, rankWith, optionIs, schemaTypeIs } from "@jsonforms/core";

export const BlogTagsSelectMultipleTester: RankedTester = rankWith(
  3,
  and(schemaTypeIs("array"), optionIs("BlogTagsSelect", true))
);

export default BlogTagsSelectMultipleTester;
